import { fork, all } from 'redux-saga/effects';
import * as goals from './goals';
export default function* rootSaga() {
  yield all([...Object.values(goals)].map(fork));
}
